export default __webpack_public_path__ + "static/media/works.3c64174b.jpg";